import { Chip, Theme, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { parseStatusTitle } from '../helpers/parseStatusTitle';

const useStyles = makeStyles<{ colorByType?: string }>()((theme: Theme, { colorByType }) => ({
  statusPillBar: {
    background: `${colorByType}14`,
    border: `1px solid ${colorByType}`,
    fontSize: '14px',
    padding: 0,
    borderRadius: '12px',
    marginBottom: '12px',
    height: '25px',
    width: 'fit-content',

    '& .MuiChip-label': {
      fontFamily: 'Inter',
      fontWeight: '500',
      color: colorByType,
      textTransform: 'capitalize',
      padding: '0px 12px 0px 12px',
    },
  },
}));

interface StatusPillBarProps {
  status: string;
}

const StatusPillBar = ({ status }: StatusPillBarProps) => {
  const theme = useTheme();

  const splitLabelByCapitalLetter = (value: string) => value.replace(/([a-z0-9])([A-Z])/g, '$1 $2');

  const statusColors = {
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    default: theme.palette.secondary.dark,
    infoLight: '#4aaac0',
    white: theme.palette.common.white,
    disabled: theme.palette.text.disabled,
  };

  const statusPillBarTypes = {
    Active: 'success',
    Draft: 'warning',
    Pending: 'warning',
    Closed: 'error',
    Abandoned: 'error',
    Archived: 'error',
    Created: 'warning',
    Deactivated: 'error',
    Completed: 'success',
    Unopened: 'warning',
    Opened: 'info',
    Rejected: 'error',
    Canceled: 'error',
    Paid: 'success',
    Unpaid: 'warning',
    Processing: 'info',
    Failed: 'error',
    CancelInProgress: 'error',
    Error: 'error',
    DistributingFunds: 'warning',
    OnHold: 'warning',
    CriticalError: 'error',
    Inactive: 'warning',
    Funding: 'warning',
    WaitingFunds: 'warning',
    InitialFunding: 'warning',
    DistributingAttyFees: 'warning',
    DistributingDeductions: 'warning',
    DistributingNetSettlement: 'warning',
    DistributingVendorFees: 'warning',
    PaidWithVendorExceptions: 'success',
    COMPLETED: 'success',
    IN_PROGRESS: 'warning',
    BLOCKED: 'error',
    INVITE_SENT: 'info',
    NOT_STARTED: 'default',
    NOT_APPLICABLE: 'default',
    InDistribution: 'infoLight',
    Withhold: 'white',
    NotStarted: 'disabled',
  };

  const currentStatus = statusPillBarTypes[status as keyof typeof statusPillBarTypes];

  const styles = useStyles({
    colorByType: statusColors[currentStatus as keyof typeof statusColors],
  });

  return <Chip label={splitLabelByCapitalLetter(parseStatusTitle(status))} className={styles.classes.statusPillBar} />;
};

export default StatusPillBar;